import React from 'react';

interface HeaderDashboardProps {
  children: React.ReactNode;
}

interface HeaderDashboardTitleProps {
  children: React.ReactNode;
}

interface HeaderDashboardActionProps {
  children: React.ReactNode;
}

interface HeaderDashboardBackButtonProps {
  onClick?: () => void;
  children?: React.ReactNode;
}

const HeaderDashboardRoot: React.FC<HeaderDashboardProps> = ({ children }) => {
  return <div className="flex items-center gap-2 mb-4 w-full">{children}</div>;
};

const HeaderDashboardTitle: React.FC<HeaderDashboardTitleProps> = ({
  children,
}) => {
  return (
    <h2 className="text-2xl font-bold flex items-center gap-2">{children}</h2>
  );
};

const HeaderDashboardAction: React.FC<HeaderDashboardActionProps> = ({
  children,
}) => {
  return <div className="flex-1 flex items-center justify-end">{children}</div>;
};

const HeaderDashboardBackButton: React.FC<HeaderDashboardBackButtonProps> = ({
  onClick,
  children,
}) => {
  return (
    <button
      onClick={onClick}
      className="cursor-pointer flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 hover:text-neutral-500 transition-colors"
      aria-label="Go back"
    >
      {children || (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      )}
    </button>
  );
};

// Create a compound component
const HeaderDashboard = Object.assign(HeaderDashboardRoot, {
  Title: HeaderDashboardTitle,
  Action: HeaderDashboardAction,
  BackButton: HeaderDashboardBackButton,
});

export { HeaderDashboard };
